document.addEventListener("DOMContentLoaded", function () {
  const elementsToAnimate = document.querySelectorAll("[data-animation]");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const animationClass = element.getAttribute("data-animation");
        const delay = element.getAttribute("data-delay");

        // 딜레이 적용 및 클래스 추가
        element.style.animationDelay = delay;
        element.classList.add(animationClass);

        // 한 번 애니메이션 후 관찰 중지
        observer.unobserve(element);
      }
    });
  });

  elementsToAnimate.forEach((el) => observer.observe(el));
});
